import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useSettings } from '../context/SettingsContext';

const About = () => {
  const { nightDiscountPct, nightDiscountEnabled } = useSettings();
  return (
  <div data-testid="about-page" className="pt-28">
    <SEO
      title="About Royal Garden Villas | Premium Villa Hosting in Lonavala Since 2024"
      description="Royal Garden Villas is a premium villa hosting company in Lonavala, Maharashtra. 7 luxury private pool villas (individual 3BHK, 4BHK, 5BHK and combo 7BHK, 8BHK, 9BHK & 12BHK), established in 2024, serving families, friend groups and corporates."
      path="/about"
      breadcrumbs={[
        { name: 'Home', url: '/' },
        { name: 'About', url: '/about' },
      ]}
    />
    <section className="py-16 md:py-20 bg-[#1B2432]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-[#F57C20] text-xs font-semibold tracking-[0.2em] uppercase mb-3">About Us</p>
        <h1 className="text-4xl sm:text-5xl text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Royal Garden <span className="text-[#F57C20] italic">Villas</span></h1>
      </div>
    </section>
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-[#6B7280] text-sm leading-relaxed space-y-5">
        <p>Royal Garden Villas is a premium villa hosting company based in Lonavala, Maharashtra. Established in 2024, we offer a curated collection of luxury private pool villas designed for families, friend groups, corporates, and event organizers.</p>
        <p>Our 4 handpicked properties &mdash; 3BHK Garden Escape, 4BHK Garden Retreat, 5BHK Garden Delight, and the grand 12BHK Celebration Villa &mdash; are equipped with private swimming pools, manicured gardens, fully-equipped kitchens, AC rooms, complimentary WiFi, indoor games, and ample parking.</p>
        <p>We take pride in delivering clean, safe, and well-maintained villas with a seamless 100% online booking experience. Our transparent pricing includes weekday/weekend rates{nightDiscountEnabled ? ` — and with our "Stay Longer, Pay Less" promo, every night from the 2nd onwards is ${nightDiscountPct}% OFF (1st night stays at actual rate).` : '.'}</p>
        <p>Whether you are planning a birthday celebration, family reunion, corporate offsite, pre-wedding shoot, or a relaxing weekend getaway &mdash; our team ensures every stay is memorable.</p>
        <h3 className="text-xl text-[#1A1A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Our <span className="text-[#F57C20] italic">Mission</span></h3>
        <p>To provide families and groups a safe, premium, and hassle-free villa experience in the hills of Lonavala at honest prices.</p>
        <h3 className="text-xl text-[#1A1A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Registered <span className="text-[#F57C20] italic">Address</span></h3>
        <p>Royal Garden Villas<br/>Lonavala, Pune District<br/>Maharashtra 410401, India</p>
        <p>Phone: <a href="tel:+919820088292" className="text-[#F57C20] hover:underline">+91 9820088292</a><br/>Email: <a href="mailto:royalgardenlonavala@gmail.com" className="text-[#F57C20] hover:underline">royalgardenlonavala@gmail.com</a></p>
        <div className="pt-6"><Link to="/villas" className="bg-[#F57C20] text-white px-8 py-3 text-sm font-semibold rounded-lg hover:bg-[#E06A10] transition-all">Explore Our Villas</Link></div>
      </div>
    </section>
  </div>
  );
};

export default About;
